import React, { useCallback, useState } from 'react';
import { Link, Redirect, Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { sections, instruments, songs, parts } from './data';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: rgb(241, 243, 244);// #eee;
  }
`;

const AppContainer = styled.div`
  text-align: center;
  height: 100%;
`;

const Logo = styled.div`
  background-image: url('https://stanfordjazz.org/wp-content/uploads/2014/11/sjw-logos-web-horizontal_sjw-logo-web-horizontal-blue-on-white.png');
  height: 80px;
  padding-left: calc(360px + 5px);
  display: inline-block;
  background-repeat: no-repeat;
  text-align: left;
  font-family: Arial;
  font-weight: 800;

  width: 60px;
  word-wrap: normal;
  
  font-size: 20px;
  letter-spacing: 2px;
  padding-top: 25px;
  color: black;

  @media only screen and (max-width: 480px){
    background-size: 250px;
    padding-left: 0;
    width: 250px;
    height: auto;
    padding-top: calc((106/320)*250px);
    text-align: center;
  }
`;

// function format(s: string, capitalize = false) {
//   let wordTransform: (w: string) => string = capitalize ?
//     w => w[0].toUpperCase() + w.substring(1) :
//     w => w;
//   return s.split('_').map(wordTransform).join(' ')
// }

const PartBtn = styled(Link)`
    display: inline-block;
    width: 150px;
    padding: 10px 12px;
    margin: 4px;
    background-color: #ddd;

    color: black;
    text-decoration: none;
    font-size: 1.2rem;
    /* align-items: stretch; */
    display:flex;
    flex-direction:column;
    justify-content:space-around;

    ${ (p: {grow?: boolean}) => p.grow && `flex-grow: 1;`}

    height: 2rem;
    /* label { border-bottom: 1px solid black; } */
`;

const FullWidth = styled.div`
  padding: 0 50px;
  margin-top: 100px;

  @media only screen and (max-width: 480px){
    margin-top: 25px;
    padding: 0 15px;
  }
`;

const AudioPlayer = styled.audio`
  position: fixed;
  top: 20px;
  right: 20px;

  @media only screen and (max-width: 480px){
    top: unset;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
  }
`;
const BackButton = styled.button`
  display: inline-block;
  border-radius: 50%;
  position: fixed;
  top: 20px;
  left: 20px;

  @media only screen and (max-width: 480px){
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
  }

  background-color: rgb(241, 243, 244);
  background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pjxzdmcgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGcgaWQ9ImluZm8iLz48ZyBpZD0iaWNvbnMiPjxwYXRoIGQ9Ik0yMCwxMGMtMi4zLTAuMi0xMCwwLTEwLDBWNmMwLTAuOC0wLjgtMS4zLTEuNC0wLjhsLTYuMyw2Yy0wLjUsMC40LTAuNSwxLjIsMCwxLjZsNi4zLDZjMC42LDAuNSwxLjQsMCwxLjQtMC44ICAgdi00YzAsMCw3LjYsMC4yLDEwLDBjMS4xLTAuMSwyLTAuOSwyLTJDMjIsMTAuOSwyMS4xLDEwLjEsMjAsMTB6IiBpZD0iYXJyb3ciLz48L2c+PC9zdmc+');
  background-repeat: no-repeat;
  background-size: 30px;
  background-position: center;
  height: 54px;
  width: 54px;
  border: none;
`;

const TBut = styled(BackButton)`
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='96px' height='215px' viewBox='0 0 96 215' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EGroup%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Group' transform='translate(8.000000, 0.000000)'%3E%3Cpath d='M0,0 C0,24.5939334 0,51.637907 0,81.1319208 C0,125.372942 24.5103681,137 40,137 C55.7573255,137 80,125.372942 80,81.1319208 C80,51.637907 80,24.5939334 80,0' id='Line' stroke='%23000000' stroke-width='15'%3E%3C/path%3E%3Cline x1='40' y1='137' x2='40' y2='197' id='Line-2' stroke='%23000000' stroke-width='15' stroke-linecap='square'%3E%3C/line%3E%3Ccircle id='Oval' fill='%23000000' cx='40' cy='201' r='14'%3E%3C/circle%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: 15px;
  left: calc(20px + 54px + 10px);

  ${(props: { pressed: boolean }) => props.pressed && `background-color: #bbb;`}
`;

// let tuningAudio = new Audio('/audios/tuning_Bb.mp3');

function TuningButton() {
  let [oscillatorNode, setOscillatorNode] = useState<OscillatorNode | null>(null);
  
  const toggle = useCallback(function toggle() {
    if (oscillatorNode) {
      // will auto-set the state
      oscillatorNode.stop();
      return;
    }

    let audioCtx = new AudioContext();
    let gainNode = audioCtx.createGain();
    gainNode.connect(audioCtx.destination);
    gainNode.gain.setValueAtTime(0, 0);
    gainNode.gain.linearRampToValueAtTime(0.2, audioCtx.currentTime + 0.6);
    

    let oscillator = audioCtx.createOscillator();
    oscillator.frequency.setValueAtTime(466.164, audioCtx.currentTime);
    oscillator.type = "square";
    oscillator.connect(gainNode);
    
    oscillator.start();
    oscillator.stop(20); // auto end the note in 20 sec if the user doesn't

    oscillator.onended = () => setOscillatorNode(null);
    setOscillatorNode(oscillator);
  }, [ oscillatorNode ]);

  return <TBut as="button" pressed={!!oscillatorNode} onClick={toggle} />;
}

const PartColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

const Flexbox = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

function Welcome() {
  return <FullWidth>
    <h2>Welcome to SJW's Real Easy Book player! </h2>
    <h3>
      You can play along with our Real Easy Book songs, and practice soloing, too. <br />
      Just follow the simple steps below.
    </h3>
    <Flexbox>
      <PartBtn to={`/i`}>Get started &gt;</PartBtn>
    </Flexbox>
  </FullWidth>
}

function PickInstrument() {
  return <FullWidth>
    <h2>First, select your instrument.</h2>
    <Flexbox>
      {
        sections.map(({ type, instruments }) =>
          <PartColumn key={type}>
            <h3>{type}</h3>
            {instruments.map(i => <PartBtn key={i.clean} to={`/i/${i.clean}`}>{i.name}</PartBtn>)}
          </PartColumn>
        )
      }
    </Flexbox>
  </FullWidth>
}

function PickSong() {
  const { instrument: instrumentParam } = useParams<{ instrument: string }>();
  const { url } = useRouteMatch();
  
  let instrument = instruments.find(i => i.clean === instrumentParam);
  if (!instrument) {
    return <Redirect to="/" />
  }
  
  return <FullWidth>
    <h2>Second, choose the song you want to play.</h2>
    <h3>We've got {instrument.name} parts for the following songs:</h3>
    <Flexbox>
    { songs.map(s => <PartBtn key={s.clean} to={`${url}/s/${s.clean}`}>{s.name}</PartBtn>)}

    </Flexbox>
  </FullWidth>
}

function PickPart() {
  const { instrument, song } = useParams<{ instrument: string, song: string }>();
  const { url } = useRouteMatch();
  if (instruments.every(i => i.clean !== instrument) || songs.every(s => s.clean !== song)) {
    return <Redirect to="/" />
  }
  
  return <FullWidth>
    {/* <label>{instrument} &gt; {song}</label> */}
    <h2>Third, select which part you'd like to play.</h2>
    <h3>The corresponding instrument or part will be left out of the mix, so you can play the part.</h3>
    <Flexbox>
      { parts.map(p => <PartBtn key={p.clean} to={`${url}/p/${p.clean}`}>{p.name}</PartBtn>) }
    </Flexbox>
  </FullWidth>
}

const PlayPageContainer = styled.div`
  padding: calc(54px + 5px) 0;
  background-color: white;
  min-height: 100vh;
`;

const Score = styled.img`
  width: 100%;
  transition: opacity 2s;
  opacity: ${ (props: { loaded: boolean }) => props.loaded ? '1' : '0'};

  user-drag: none; 
  user-select: none;
`;

function Play() {
  const history = useHistory();
  let [scoreImageLoaded, setScoreImageLoaded] = useState(false);
  const { instrument: instrumentParam, song, part: partParam } = useParams<{ instrument: string, song: string, part: string }>();

  let instrument = instruments.find(i => i.clean === instrumentParam);
  let part = parts.find(i => i.clean === partParam);
  if (!instrument || songs.every(s => s.clean !== song) || !part) {
    return <Redirect to="/" />
  }

  let scoreSrc = `/scores/${song}/${instrument.key}/${part.scoreAlias ?? part.clean}.png`;

  return <PlayPageContainer>
    <BackButton onClick={ () => history.goBack() } />
    <TuningButton />
    <AudioPlayer autoPlay controls src={`/audios/${song}/${part.clean}.mp3`} />
    <Score src={scoreSrc} alt="Score" loaded={scoreImageLoaded} onLoad={ () => setScoreImageLoaded(true) }/>
  </ PlayPageContainer>;
}

function Header() {
  return <Link to="/"><Logo>Pick Your Mix</Logo></Link>;
}


function App() {
  return <AppContainer>
    <GlobalStyle />
    <Switch>
      <Route exact path="/i/:instrument/s/:song/p/:part" />
      <Route path="/" component={Header} />
    </Switch>
    <Switch>
      <Route exact path="/" component={Welcome} />
      <Route exact path="/i" component={PickInstrument} />
      <Route exact path="/i/:instrument" component={PickSong} />
      <Route exact path="/i/:instrument/s/:song" component={PickPart} />
      <Route exact path="/i/:instrument/s/:song/p/:part" component={Play} />
    </Switch>
  </AppContainer>
}

export default App;
